<template>
<div>
    <div class="card-title wise-card-title" style="padding-bottom:10px;">
      <span>자주 묻는 질문</span>
      <span class="float-right">
        <input style="margin-left:5px;" v-model="filter" class="form-control" placeholder="검색" type="text"></input>
      </span>
    </div>
    <b-table id='freeBoardTable' :hover="hover" responsive="sm" :filter="filter"
    :items="boardItems" :fields="boardFields" :current-page="currentPage" :per-page="perPage" thead-class="hidden_header"  @row-clicked="contentClick">
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(boardItems)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
    <b-modal size="lg" class="modal-primary" v-model="largeModal" @ok="largeModal = false">
      <div  class="modal-body">
        <div id="freeboardModal" ></div>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-right" variant="primary" @click="largeModal=false">
          닫기
        </b-btn>
      </div>
    </b-modal>
</div>
</template>

<script>
export default {
  name: 'c-table',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    largeModal: false,
    content : {
      title:'',
      registered:''
    },
    title : '',
    filter : null
  },
  data: () => {
    return {
      boardItems: [
        {title: '유튜브 Frequency Q&A', registered: '2019/1/22',
          type:'img',
          content: '<img class="helpImg" src="static/img/contents/board_content_3.png" height="100%" width="100%">'
        },
        {title: 'TV매체가 포함된 예측분석', registered: '2018/11/26',
          type:'img',
          content: '<img class="helpImg" src="static/img/contents/board_content_1.jpg" height="100%" width="100%">'
        },
        {title: 'GRPs / Reach에 대한 개념', registered: '2018/11/26',
          type:'img',
          content: '<img class="helpImg" src="static/img/contents/board_content_2.jpg" height="100%" width="100%">'
        },
      ],
      boardFields: [
        {key: 'title'},
        {key: 'registered'},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    }
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    contentClick(record, index){
      this.content = record;
      this.title = record.title;
      this.largeModal = true;

      // noticeModal
      var elem = document.getElementById('freeboardModal');
      if(record.type == 'img'){
        // var temp = elem.createElement('div');
        elem.innerHTML = null;
        elem.innerHTML = record.content;
        this.largeModal = true;
      }else{
        elem.innerHTML = null;
        this.content = record;
      }

      this.title = record.title;
      this.largeModal = true;
    }
  }
}
</script>
<style>
#freeBoardTable .hidden_header {
  display: none;
}
</style>
<style scoped>
.modal-body{
    max-height: 700px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/FreeBoard.vue